import { render, staticRenderFns } from "./QueriesOverview.vue?vue&type=template&id=7654cd94&scoped=true&"
import script from "./QueriesOverview.vue?vue&type=script&lang=js&"
export * from "./QueriesOverview.vue?vue&type=script&lang=js&"
import style0 from "./QueriesOverview.vue?vue&type=style&index=0&id=7654cd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7654cd94",
  null
  
)

export default component.exports